import { useState, useCallback, RefObject } from 'react';

import { DROPDOWN_CONSTANTS, POSITIONS, VerticalPosition, HorizontalPosition } from '../constants';

export const useDropdownPosition = (
  containerRef: RefObject<HTMLDivElement>,
  dropdownRef: RefObject<HTMLDivElement>,
) => {
  const [dropdownPosition, setDropdownPosition] = useState<VerticalPosition>(
    POSITIONS.VERTICAL.DOWN,
  );
  const [dropdownHorizontalPosition, setDropdownHorizontalPosition] = useState<HorizontalPosition>(
    POSITIONS.HORIZONTAL.LEFT,
  );

  const calculateDropdownPosition = useCallback(() => {
    if (containerRef.current) {
      const containerRect = containerRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;

      const spaceBelow = viewportHeight - containerRect.bottom;
      const spaceAbove = containerRect.top;
      const dropdownHeight =
        dropdownRef.current?.getBoundingClientRect().height ||
        Math.min(
          DROPDOWN_CONSTANTS.MAX_HEIGHT,
          window.innerHeight * DROPDOWN_CONSTANTS.VIEWPORT_HEIGHT_RATIO,
        );

      setDropdownPosition(
        spaceBelow >= dropdownHeight || spaceBelow > spaceAbove
          ? POSITIONS.VERTICAL.DOWN
          : POSITIONS.VERTICAL.UP,
      );

      const dropdownWidth =
        dropdownRef.current?.getBoundingClientRect().width || DROPDOWN_CONSTANTS.MIN_WIDTH;
      const rightOverflow = containerRect.left + dropdownWidth - viewportWidth;
      setDropdownHorizontalPosition(
        rightOverflow > 0 ? POSITIONS.HORIZONTAL.RIGHT : POSITIONS.HORIZONTAL.LEFT,
      );
    }
  }, [containerRef, dropdownRef]);

  return {
    dropdownPosition,
    dropdownHorizontalPosition,
    calculateDropdownPosition,
  };
};
